import React, { useState } from 'react'
import requesthead from "../../assets/requesthead.svg"
import greenline from "../../assets/greenline.svg"
import "./InvestmentRequest.css"
import waheedIconForm from "../../assets/icons/waheedIcon.png"
import waheedbg from "../../assets/icons/bg.svg"
import footer from "../../assets/footer.svg"
import { useTranslation } from "react-i18next";

export default function InvestmentRequest() {
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    website: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState({
    submitting: false,
    success: null,  // null, true, or false
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus({ submitting: true, success: null, message: "" });  // Set submitting state

    try {
      const response = await fetch(
        "https://formspree.io/f/xgvorllb",  // Replace with your Formspree ID!
        {
          method: "POST",
          body: JSON.stringify({
            email: formData.email,
            message: `
            تم إرسال طلب استثمار جديد من قبل ${formData.name} 
            
            بالبريد الإلكتروني  : ${formData.email} 
            ورقم الهاتف : ${formData.phone} 
            والموقع الإلكتروني : ${formData.website} 
            
            والرسالة : ${formData.message}
            `
          }),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json", // Specify JSON content type
          },
        }
      );

      if (response.ok) {
        setFormStatus({
          submitting: false,
          success: true,
          message: t("contact.successMessage"),
        });
        setFormData({
          name: "",
          email: "",
          phone: "",
          website: "",
          message: "",
        });
      } else {
        const errorData = await response.json(); // Get error details
        setFormStatus({
          submitting: false,
          success: false,
          message: t("contact.errorMessage") + (errorData.errors ? ": " + errorData.errors.map(err => err.message).join(", ") : ""),
        });
      }
    } catch (error) {
      console.error("Form Submission Error:", error);
      setFormStatus({
        submitting: false,
        success: false,
        message: t("contact.errorMessage") + ": " + error.message,
      });
    }
  };

  return (
    <div>
      <img src={requesthead} className="request-head" />

      <div className="request-investment">
        <img src={greenline} className="green-line RequestGreenLine" />
        <div className="form-container">
          <h2 className="form-title">{t("contact.title")}</h2>

          <form className="form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder={t("contact.name")}
                className="form-input"
                required
              />
              <input
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder={t("contact.email")}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder={t("contact.phone")}
                className="form-input"
                required
              />
              <input
                type="text"
                name="name"
                value={formData.website}
                onChange={handleChange}
                placeholder={t("contact.website")}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder={t("contact.message")}
                className="form-textarea"
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-btn" disabled={formStatus.submitting}> {t("contact.send")}</button>
          </form>
        </div>
        <img src={waheedbg} className="waheedbgform" />
        <img src={waheedIconForm} alt="Person" className="waheed-iconForm" />
        <img src={footer} className="footer-form" />
      </div>
    </div>
  );
}
